import { useCallback, useMemo } from 'react'
import { buildMentionFlatItems } from './composerMentionFlatItems.js'
import { useComposerMentionEnterKey } from './useComposerMentionEnterKey.js'

export function useComposerMentionsInsert(editor, refs, mentionUsers, mentionAgentsList) {
  const { mentionOpenRef, mentionRangeRef, setMentionTrigger, setMentionAnchor } = refs

  const insertMention = useCallback(
    (item) => {
      const range = mentionRangeRef.current
      if (!editor || editor.isDestroyed || !range || !item?.label) return
      editor
        .chain()
        .focus()
        .deleteRange(range)
        .insertContent([
          { type: 'text', text: `@${item.label}`, marks: [{ type: 'composerMention', attrs: { id: item.id, kind: item.kind } }] },
          { type: 'text', text: ' ' },
        ])
        .run()
      mentionRangeRef.current = null
      setMentionTrigger(null)
      setMentionAnchor(null)
      mentionOpenRef.current = false
    },
    [editor, mentionOpenRef, mentionRangeRef, setMentionAnchor, setMentionTrigger],
  )

  const mentionFlatItems = useMemo(() => buildMentionFlatItems(mentionUsers, mentionAgentsList), [mentionUsers, mentionAgentsList])
  useComposerMentionEnterKey(editor, refs, mentionFlatItems, insertMention)

  return { insertMention }
}
